let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jL8Zq")).then(() => parcelRequire('kg72t'));